const translations = {
  'pt-BR': {
    // Navbar
    'nav.channels': 'Canais',
    'nav.solutions': 'Soluções',
    'nav.tools': 'Ferramentas',
    'nav.templates': 'Templates',
    'nav.resources': 'Recursos',
    'nav.integrations': 'Integrações',
    'nav.login': 'Entrar',
    'nav.startFree': 'Começar grátis',
    'nav.dashboard': 'Dashboard',
    'nav.logout': 'Sair',

    // Navbar - Channels dropdown
    'nav.channels.whatsapp.desc': 'Automação para Business API',
    'nav.channels.instagram.desc': 'DMs, Stories e Reels',
    'nav.channels.facebook.desc': 'Messenger e Comentários',
    'nav.channels.tiktok.desc': 'Engajamento automático',
    'nav.channels.website.desc': 'Chat flutuante e Popups',

    // Navbar - Solutions dropdown
    'nav.solutions.useCases': 'Casos de Uso',
    'nav.solutions.industries': 'Indústrias',
    'nav.solutions.leadQualification': 'Qualificação de Leads',
    'nav.solutions.appointments': 'Agendamentos',
    'nav.solutions.faqAnswers': 'Respostas de FAQ',
    'nav.solutions.ordersAndSales': 'Pedidos e Vendas',
    'nav.solutions.customerSupport': 'Suporte ao Cliente',
    'nav.solutions.ecommerce': 'E-commerce',
    'nav.solutions.realEstate': 'Imobiliário',
    'nav.solutions.education': 'Educação',
    'nav.solutions.healthcare': 'Saúde',
    'nav.solutions.beautyAesthetics': 'Estética e Beleza',
    'nav.solutions.restaurants': 'Restaurantes',

    // Navbar - Tools dropdown
    'nav.tools.capturePopup': 'Popup de Captura',
    'nav.tools.clickToChatAds': 'Anúncios Click-to-Chat',
    'nav.tools.storyAutomation': 'Automação de Stories',
    'nav.tools.chatButton': 'Botão de Chat',
    'nav.tools.commentReplies': 'Resposta a Comentários',
    'nav.tools.qrCodes': 'Códigos QR',
    'nav.tools.reelsReplies': 'Resposta a Reels',
    'nav.tools.liveChat': 'Live Chat',
    'nav.tools.broadcasts': 'Broadcasts',

    // Navbar - Resources dropdown
    'nav.resources.blog': 'Blog',
    'nav.resources.docs': 'Documentação',
    'nav.resources.successStories': 'Casos de Sucesso',
    'nav.resources.affiliateProgram': 'Programa de Afiliados',

    // Navbar - Mobile
    'nav.mobile.prices': 'Preços',

    // Hero Section
    'hero.title.line1': 'AUMENTE VENDAS',
    'hero.title.line2': 'NA SUA',
    'hero.subtitle': 'Junte-se a',
    'hero.subtitleHighlight': 'mais de 18.000 empresas',
    'hero.subtitleEnd': 'usando IA para interagir com seus clientes.',
    'hero.selectCase': 'Ou selecione um caso típico',
    'hero.imageAlt': 'Profissional em clínica',
    'hero.businessTypes.aestheticClinic': 'clínica estética',
    'hero.businessTypes.realEstate': 'imobiliária',
    'hero.businessTypes.beautySalon': 'salão de beleza',
    'hero.businessTypes.dentalClinic': 'clínica odontológica',
    'hero.businessTypes.medicalCenter': 'centro médico',

    // AI Tools Section
    'aiTools.headline': 'Ferramentas de IA',

    // Features Section
    'features.headline': 'Funcionalidades',

    // Testimonials Section
    'testimonials.headline': 'O que nossos clientes dizem',

    // CTA Section
    'cta.headline': 'Pronto para automatizar suas vendas?',
    'cta.subtitle': 'Comece agora e veja resultados em minutos.',
    'cta.button': 'Começar grátis',

    // Pricing Section
    'pricing.headline': 'Planos e Preços',
    'pricing.starter': 'Starter',
    'pricing.professional': 'Profissional',
    'pricing.enterprise': 'Enterprise',
    'pricing.startFree': 'Começar grátis',
    'pricing.talkToSales': 'Falar com vendas',

    // FAQ Section
    'faq.headline': 'Perguntas Frequentes',

    // Footer
    'footer.description': 'A plataforma #1 de automação de WhatsApp e Instagram para empresas.',
    'footer.product': 'Produto',
    'footer.features': 'Funcionalidades',
    'footer.pricing': 'Preços',
    'footer.integrations': 'Integrações',
    'footer.api': 'API',
    'footer.company': 'Empresa',
    'footer.aboutUs': 'Sobre Nós',
    'footer.blog': 'Blog',
    'footer.affiliates': 'Afiliados',
    'footer.contact': 'Contato',
    'footer.resources': 'Recursos',
    'footer.docs': 'Documentação',
    'footer.templates': 'Templates',
    'footer.successStories': 'Casos de Sucesso',
    'footer.legal': 'Legal',
    'footer.privacy': 'Privacidade',
    'footer.terms': 'Termos de Uso',
    'footer.copyright': '© 2026 ChatAlfa. Todos os direitos reservados.',
    'footer.officialPartner': 'Parceiro Oficial',

    // Dashboard - Sidebar
    'sidebar.home': 'Início',
    'sidebar.automation': 'Automação',
    'sidebar.calendar': 'Calendário',
    'sidebar.conversations': 'Conversas',
    'sidebar.leads': 'Leads',
    'sidebar.contacts': 'Contatos',
    'sidebar.webWidget': 'Widget Web',
    'sidebar.bookingSite': 'Site de Reservas',
    'sidebar.billing': 'Faturamento',
    'sidebar.settings': 'Configurações',
    'sidebar.upgrade': 'Fazer Upgrade',
    'sidebar.logout': 'Sair',

    // Dashboard - Common UI
    'common.save': 'Salvar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Excluir',
    'common.create': 'Criar',
    'common.edit': 'Editar',
    'common.back': 'Voltar',
    'common.continue': 'Continuar',
    'common.loading': 'Carregando...',
    'common.saving': 'Salvando...',
    'common.saveChanges': 'Salvar alterações',
    'common.export': 'Exportar',
    'common.all': 'Todos',
    'common.active': 'Ativo',
    'common.link': 'Vincular',
    'common.visit': 'Visitar',
    'common.preview': 'Pré-visualizar',
    'common.publish': 'Publicar',
    'common.copy': 'Copiar',
    'common.copied': 'Copiado!',
    'common.today': 'Hoje',
    'common.day': 'Dia',
    'common.week': 'Semana',
    'common.confirmed': 'confirmado',
    'common.pending': 'pendente',
    'common.status': 'Status',
    'common.email': 'Email',
    'common.phone': 'Telefone',
    'common.tags': 'Tags',
    'common.notes': 'Notas',
    'common.total': 'Total',
    'common.name': 'Nome',
    'common.contact': 'Contato',
    'common.channel': 'Canal',
    'common.date': 'Data',
    'common.configuration': 'Configuração',

    // Flow Builder
    'flow.saveChanges': 'Salvar Alterações',
    'flow.saving': 'Salvando...',
    'flow.testWithAI': 'Testar com IA',
    'flow.textMessage': 'Mensagem de Texto',
    'flow.choiceButtons': 'Botões de Opção',
    'flow.humanHandoff': 'Transferência Humana',
    'flow.autosaveActive': 'Salvamento automático ativo',
    'flow.editorBeta': 'Editor Beta',
    'flow.aiResponse': 'Resposta de IA',
    'flow.multipleChoice': 'Pergunta Múltipla',
    'flow.specialAction': 'Ação Especial',
    'flow.escalateToHuman': 'Escalar para Humano',
    'flow.escalateDescription': 'A IA será pausada e um agente real receberá uma notificação.',
    'flow.writeBotMessage': 'Escreva a mensagem do bot...',
    'flow.selectOption': 'Selecione uma opção:',
    'flow.option': 'Opção',
    'flow.newMessage': 'Nova mensagem',
    'flow.welcomeMessage': 'Bem-vindo! Como posso ajudar?',
    'flow.yesInterested': 'Sim, tenho interesse',
    'flow.noThanks': 'Não, obrigado',
    'flow.savedAt': 'Salvo às',
    'flow.sendMessage': 'Envie uma mensagem para testar seu bot',
    'flow.typeMessage': 'Digite uma mensagem...',
    'flow.errorProcessing': 'Erro ao processar mensagem.',

    // Dashboard Home
    'dashboard.welcome': 'Olá! Bem-vindo de volta',
    'dashboard.summary': 'Aqui está um resumo do que está acontecendo no ChatAlfa.',
    'dashboard.exploreTemplates': 'Explorar Templates',
    'dashboard.createNewBot': 'Criar Novo Bot',
    'dashboard.myBots': 'Meus Bots',
    'dashboard.activeConversations': 'Conversas Ativas',
    'dashboard.totalContacts': 'Total de Contatos',
    'dashboard.messages': 'Mensagens',
    'dashboard.quickSetup': 'Configuração Rápida',
    'dashboard.bookingPage': 'Página de Reservas',
    'dashboard.bookingPageDesc': 'Crie um site público para que seus clientes agendem consultas diretamente.',
    'dashboard.setupSite': 'Configurar site',
    'dashboard.aiAutomation': 'Automação com IA',
    'dashboard.aiAutomationDesc': 'Ative respostas inteligentes baseadas em GPT-4 para não perder nenhum lead.',
    'dashboard.activateAI': 'Ativar IA',
    'dashboard.calendar': 'Calendário',
    'dashboard.calendarDesc': 'Gerencie todas as suas reservas e horários em um só lugar.',
    'dashboard.viewCalendar': 'Ver meu calendário',
    'dashboard.importContacts': 'Importar Contatos',
    'dashboard.importContactsDesc': 'Carregue sua base de dados atual para iniciar conversas em massa ou lembretes.',
    'dashboard.uploadCSV': 'Enviar CSV/Excel',
    'dashboard.growthTips': 'Dicas para Crescer',
    'dashboard.boostBookings': 'Aumente suas reservas',
    'dashboard.boostBookingsDesc': 'Use o código QR no seu estabelecimento para que os clientes agendem a próxima consulta sozinhos pelo WhatsApp.',
    'dashboard.getQR': 'Obter meu QR',
    'dashboard.connectionStatus': 'Status de Conexão',

    // Leads Page
    'leads.title': 'Leads',
    'leads.subtitle': 'Gerencie seus leads e contatos capturados',
    'leads.exportCSV': 'Exportar CSV',
    'leads.searchPlaceholder': 'Buscar por nome, email ou telefone...',
    'leads.statusNew': 'Novo',
    'leads.statusContacted': 'Contactado',
    'leads.statusQualified': 'Qualificado',
    'leads.statusConverted': 'Convertido',
    'leads.noLeads': 'Nenhum lead encontrado',
    'leads.noLeadsDesc': 'Os leads capturados pelos seus chatbots aparecerão aqui',
    'leads.viewDetails': 'Ver detalhes',
    'leads.markAsContacted': 'Marcar como contactado',
    'leads.showing': 'Mostrando',
    'leads.of': 'de',
    'leads.newTag': 'Nova tag',
    'leads.addNote': 'Adicionar uma nota...',
    'leads.noNotes': 'Nenhuma nota ainda',
    'leads.conversationHistory': 'Histórico de Conversas',
    'leads.noConversations': 'Nenhuma conversa registrada',
    'leads.deleteNote': 'Excluir esta nota?',

    // Calendar Page
    'calendar.title': 'Calendário',
    'calendar.allSpecialists': 'Todos os especialistas',
    'calendar.setupComplete': 'Configuração 75% completa',
    'calendar.setupReminder': 'Só falta ativar os lembretes por WhatsApp para automatizar suas vendas 100%.',
    'calendar.completeSetup': 'Completar configuração',
    'calendar.client': 'Cliente',
    'calendar.service': 'Serviço',
    'calendar.dayNames': ['seg', 'ter', 'qua', 'qui', 'sex', 'sáb', 'dom'],
    'calendar.dayLetters': ['d', 's', 't', 'q', 'q', 's', 's'],
    'calendar.connectCalendar': 'Conectar o calendário',
    'calendar.activateReminders': 'Ativar lembretes',
    'calendar.createFirstBooking': 'Criar sua primeira reserva',
    'calendar.setupServices': 'Configurar seus serviços',
    'calendar.addSpecialists': 'Adicionar especialistas',
    'calendar.createBookingPage': 'Criar página de reservas',
    'calendar.activateMessageAutomation': 'Ativar automação de mensagens',

    // Billing Page
    'billing.title': 'Faturamento',
    'billing.subtitle': 'Gerencie seu plano e uso de conversas',
    'billing.loadError': 'Erro ao carregar informações de assinatura',
    'billing.currentPlan': 'Plano Atual',
    'billing.paymentPending': 'Pagamento pendente',
    'billing.cancelled': 'Cancelado',
    'billing.perMonth': '/mês',
    'billing.conversationsThisMonth': 'Conversas este mês',
    'billing.nearLimit': 'Você está próximo do limite! Considere fazer upgrade.',
    'billing.nextRenewal': 'Próxima renovação',
    'billing.upgrade': 'Fazer Upgrade',
    'billing.recommended': 'Recomendado',
    'billing.conversationsPerMonth': 'conversas/mês',
    'billing.upgradeTo': 'Upgrade para',
    'billing.websiteChat': 'Website chat',
    'billing.qrCodes': 'QR Codes',
    'billing.whatsappInstagram': 'WhatsApp + Instagram',
    'billing.chatgptIntegrated': 'ChatGPT integrado',
    'billing.massBroadcasts': 'Broadcasts em massa',
    'billing.everythingInBusiness': 'Tudo do Business',
    'billing.support247': 'Suporte 24/7',
    'billing.dedicatedManager': 'Gerente dedicado',
    'billing.manageSubscription': 'Gerenciar Assinatura',
    'billing.manageSubDesc': 'Acesse o portal de faturamento para atualizar método de pagamento, ver faturas ou cancelar assinatura.',
    'billing.openBillingPortal': 'Abrir Portal de Faturamento',
    'billing.usageTip': 'Dica de uso',
    'billing.usageTipDesc': 'Uma conversa é contada quando um usuário inicia uma interação com seu bot. Todas as mensagens dentro de uma janela de 24 horas contam como uma única conversa.',

    // Booking Page Creator
    'booking.title': 'Site de Reservas',
    'booking.subtitle': 'Configure sua página pública para que os clientes agendem consultas diretamente.',
    'booking.savedSuccess': 'Configuração salva com sucesso!',
    'booking.saveError': 'Erro ao salvar a configuração',
    'booking.connectionError': 'Erro de conexão com o servidor',
    'booking.tabGeneral': 'Geral',
    'booking.tabServices': 'Serviços',
    'booking.tabAppearance': 'Aparência',
    'booking.tabBotIntegration': 'Integração Bot',
    'booking.generalInfo': 'Informações Gerais',
    'booking.clinicName': 'Nome da Clínica / Negócio',
    'booking.clinicNamePlaceholder': 'Ex: Clínica Dental São José',
    'booking.slug': 'URL Amigável (Slug)',
    'booking.shortDescription': 'Descrição Curta',
    'booking.descriptionPlaceholder': 'Descreva o que você faz...',
    'booking.contactPhone': 'Telefone de Contato',
    'booking.address': 'Endereço',
    'booking.addressPlaceholder': 'Rua Exemplo, 123, São Paulo',
    'booking.pageUrl': 'URL da sua página',
    'booking.yourServices': 'Seus Serviços',
    'booking.addService': 'Adicionar Serviço',
    'booking.serviceName': 'Nome do Serviço',
    'booking.serviceNamePlaceholder': 'Ex: Limpeza de pele',
    'booking.price': 'Preço (R$)',
    'booking.duration': 'Duração',
    'booking.serviceDescription': 'Descrição do Serviço',
    'booking.serviceDescPlaceholder': 'Breve explicação do que inclui o serviço.',
    'booking.botIntegration': 'Integração com o Bot',
    'booking.autoBookingAI': 'Reserva Automática por IA',
    'booking.autoBookingDesc': 'Seu bot de IA pode agendar consultas usando estes serviços.',
    'booking.bookingFlow': 'Fluxo de Reserva',
    'booking.flowStep1': 'Cliente escolhe o serviço',
    'booking.flowStep2': 'IA verifica disponibilidade no Calendário',
    'booking.flowStep3': 'Confirmação enviada via WhatsApp',

    // Widget Generator
    'widget.title': 'Widget Web',
    'widget.subtitle': 'Integre seu agente de IA em qualquer site com apenas uma linha de código.',
    'widget.view': 'Visualizar',
    'widget.customization': 'Personalização',
    'widget.customizationDesc': 'Configure como o chat aparecerá no seu site.',
    'widget.activeBot': 'Bot Ativo',
    'widget.brandColor': 'Cor da Marca',
    'widget.chatTitle': 'Título do Chat',
    'widget.chatTitlePlaceholder': 'Ex: Chat com Suporte',
    'widget.welcomeMessage': 'Mensagem de Boas-vindas',
    'widget.welcomePlaceholder': 'Ex: Olá! Como posso ajudar?',
    'widget.mobileOptimized': 'Otimizado para celular',
    'widget.mobileDesc': 'O widget se adapta automaticamente ao tamanho da tela, garantindo uma experiência premium em dispositivos móveis.',
    'widget.testMobile': 'Testar no celular',
    'widget.installCode': 'Código de Instalação',
    'widget.installDesc': 'Copie este código e cole antes da tag </body> no seu HTML.',
    'widget.sitePreview': 'Pré-visualização no seu site...',
    'widget.online': 'Online',
    'widget.typePlaceholder': 'Digite uma mensagem...',
    'widget.defaultTitle': 'Chat com IA',
    'widget.defaultWelcome': 'Olá! Como posso ajudar você hoje?',
    'widget.welcomeMessagePlaceholder': 'Ex: Olá! Como posso ajudar?',
    'widget.mobileOptimizedDesc': 'O widget se adapta automaticamente ao tamanho da tela, garantindo uma experiência premium em dispositivos móveis.',
    'widget.testOnMobile': 'Testar no celular',
    'widget.installCodeDesc': 'Copie este código e cole antes da tag </body> no seu HTML.',
    'widget.previewOnSite': 'Pré-visualização no seu site...',

    // Booking - missing keys
    'booking.slugPlaceholder': 'ex: clinica-dental-alfa',
    'booking.shortDescriptionPlaceholder': 'Descreva o que você faz...',
    'booking.contactPhonePlaceholder': '+55 11 99999-9999',
    'booking.serviceDescriptionPlaceholder': 'Breve explicação do que inclui o serviço.',
    'booking.visit': 'Visitar',

    // Calendar - missing key
    'calendar.configureServices': 'Configurar seus serviços',

    // Onboarding Page
    'onboarding.companyInfo': 'Informações da sua empresa',
    'onboarding.step1Title': 'Escolha a indústria',
    'onboarding.step2Title': 'Configure os serviços',
    'onboarding.step3Title': 'Presença online',
    'onboarding.step4Title': 'Primeira reserva',
    'onboarding.copyright': '© 2026 ChatAlfa - Impulsionado por IA',
    'onboarding.chooseIndustry': 'Escolha sua indústria',
    'onboarding.chooseIndustryDesc': 'Vamos carregar textos, intenções e tom otimizados para o seu tipo de negócio.',
    'onboarding.industryLabel': 'Indústria',
    'onboarding.specialtyLabel': 'Especialidade',
    'onboarding.chooseSpecialty': 'Escolha a especialidade',
    'onboarding.teamSizeLabel': 'Quantas pessoas trabalham no seu negócio?',
    'onboarding.digitalReceptionist': 'Recepcionista digital 24/7',
    'onboarding.setupCalendar': 'Configure seu calendário',
    'onboarding.setupCalendarDesc': 'Seus pacientes podem agendar consultas 24/7 — mesmo enquanto você descansa.',
    'onboarding.companyNameLabel': 'Nome da empresa',
    'onboarding.companyNamePlaceholder': 'Ex. Clínica Dental Alfa',
    'onboarding.phoneLabel': 'Número de telefone da empresa',
    'onboarding.phonePlaceholder': '+55 11 99999-9999',
    'onboarding.saveTime': 'Economize tempo valioso',
    'onboarding.saveTimeDesc': 'Recupere até 3 horas por semana para o cuidado dos seus pacientes ou sua família.',
    'onboarding.autoReminders': 'Lembretes automáticos',
    'onboarding.reduceNoShows': 'Reduza as faltas',
    'onboarding.reminderConfirmation': 'Confirmação de reserva',
    'onboarding.reminderConfirmationDesc': 'O paciente recebe confirmação instantânea após agendar',
    'onboarding.reminder24h': 'Lembrete em 24h',
    'onboarding.reminder24hDesc': 'Uma mensagem que lembra da consulta com 3 botões para confirmar, reagendar ou cancelar',
    'onboarding.reminder2h': 'Lembrete em 2h',
    'onboarding.reminder2hDesc': 'Lembrete no mesmo dia para que os pacientes não esqueçam da consulta',
    'onboarding.provenEfficiency': 'Eficácia comprovada',
    'onboarding.provenEfficiencyDesc': 'Isso reduz as faltas em até 38% — menos horários vazios na sua agenda.',
    'onboarding.automateMessages': 'Automatize as mensagens',
    'onboarding.automateMessagesIntro': 'Automatize mensagens recebidas',
    'onboarding.automateMessagesDesc': 'Gostaria de um recepcionista digital para responder mensagens e agendar consultas automaticamente?',
    'onboarding.yesAutomate': 'Gostaria de automatizar as mensagens',
    'onboarding.yesAutomateDesc': 'Excelente! Seu recepcionista digital estará pronto.',
    'onboarding.notNow': 'Agora não',
    'onboarding.firstBooking': 'Primeira reserva',
    'onboarding.firstBookingDesc': 'Clique no botão abaixo para criar uma reserva de teste. Enviaremos a confirmação para',
    'onboarding.notConfirmed': 'Não confirmada',
    'onboarding.initialConsultation': 'Consulta inicial',
    'onboarding.by': 'por',
    'onboarding.markConfirmed': 'Marcar como confirmada',
    'onboarding.createFirstBooking': 'Criar minha primeira reserva',
    'onboarding.done': 'Pronto! Notificação enviada',
    'onboarding.doneDesc': 'Você não precisa ficar atrás dos pacientes — enviaremos os lembretes e atualizaremos o status automaticamente quando responderem.',
    'onboarding.confirmed': 'Confirmada',
    'onboarding.finish': 'Finalizar',

    // Onboarding industries
    'onboarding.ind.salud': 'Saúde',
    'onboarding.ind.saludDesc': 'Clínicas, médicos, dentistas e profissionais médicos licenciados',
    'onboarding.ind.bienestar': 'Bem-estar e saúde integrativa',
    'onboarding.ind.bienestarDesc': 'Nutricionistas, osteopatas, quiropráticos e profissionais de saúde holística',
    'onboarding.ind.belleza': 'Beleza e cuidado pessoal',
    'onboarding.ind.bellezaDesc': 'Salões, spas, barbearias, cuidados com a pele e profissionais cosméticos',
    'onboarding.ind.fitness': 'Fitness e bem-estar',
    'onboarding.ind.fitnessDesc': 'Academias, personal trainers, instrutores de yoga ou pilates',
    'onboarding.ind.auto': 'Serviços automotivos e de transporte',
    'onboarding.ind.autoDesc': 'Negócios que oferecem reparo de veículos, transporte ou serviços de entrega',
    'onboarding.ind.educacion': 'Educação e coaching',
    'onboarding.ind.educacionDesc': 'Tutores, formadores ou coaches pessoais e de negócios',
    'onboarding.ind.creativos': 'Eventos e criativos',
    'onboarding.ind.creativosDesc': 'Organizadores de eventos, fotógrafos, designers e freelancers criativos',
    'onboarding.ind.alimentos': 'Alimentação e entregas',
    'onboarding.ind.alimentosDesc': 'Restaurantes, catering ou serviços de entrega de refeições',
    'onboarding.ind.hogar': 'Serviços para o lar e locais',
    'onboarding.ind.hogarDesc': 'Limpeza, reparos e outros serviços domésticos locais',
    'onboarding.ind.mascotas': 'Serviços para pets',
    'onboarding.ind.mascotasDesc': 'Grooming, adestramento, hospedagem ou serviços veterinários',
    'onboarding.ind.inmobiliaria': 'Imobiliário',
    'onboarding.ind.inmobiliariaDesc': 'Agentes, corretores ou serviços de administração de imóveis',
    'onboarding.ind.viajes': 'Viagens',
    'onboarding.ind.viajesDesc': 'Agências de viagem, guias ou serviços relacionados à hospitalidade',
    'onboarding.ind.retail': 'Varejo e e-commerce',
    'onboarding.ind.retailDesc': 'Lojas online ou físicas que vendem produtos',
    'onboarding.ind.pro': 'Serviços profissionais',
    'onboarding.ind.proDesc': 'Finanças, jurídico, agências e profissionais independentes',

    // Onboarding specialties
    'onboarding.spec.aestheticMedicine': 'Medicina estética',
    'onboarding.spec.cardiology': 'Cardiologia',
    'onboarding.spec.dentistry': 'Odontologia',
    'onboarding.spec.dermatology': 'Dermatologia',
    'onboarding.spec.endocrinology': 'Endocrinologia',
    'onboarding.spec.ent': 'Otorrinolaringologia (ORL)',
    'onboarding.spec.multiClinic': 'Clínica multidisciplinar',
    'onboarding.spec.gynecology': 'Ginecologia',
    'onboarding.spec.neurology': 'Neurologia',
    'onboarding.spec.oncology': 'Oncologia',
    'onboarding.spec.ophthalmology': 'Oftalmologia',
    'onboarding.spec.orthopedics': 'Ortopedia',
    'onboarding.spec.pediatrics': 'Pediatria',
    'onboarding.spec.mentalHealth': 'Saúde mental',
    'onboarding.spec.surgery': 'Cirurgia',
    'onboarding.spec.other': 'Outra',
  },

  es: {
    // Navbar
    'nav.channels': 'Canales',
    'nav.solutions': 'Soluciones',
    'nav.tools': 'Herramientas',
    'nav.templates': 'Plantillas',
    'nav.resources': 'Recursos',
    'nav.integrations': 'Integraciones',
    'nav.login': 'Iniciar sesión',
    'nav.startFree': 'Empezar gratis',
    'nav.dashboard': 'Dashboard',
    'nav.logout': 'Salir',

    // Navbar - Channels dropdown
    'nav.channels.whatsapp.desc': 'Automatización para Business API',
    'nav.channels.instagram.desc': 'DMs, Stories y Reels',
    'nav.channels.facebook.desc': 'Messenger y Comentarios',
    'nav.channels.tiktok.desc': 'Engagement automático',
    'nav.channels.website.desc': 'Chat flotante y Popups',

    // Navbar - Solutions dropdown
    'nav.solutions.useCases': 'Casos de Uso',
    'nav.solutions.industries': 'Industrias',
    'nav.solutions.leadQualification': 'Calificación de Leads',
    'nav.solutions.appointments': 'Citas',
    'nav.solutions.faqAnswers': 'Respuestas de FAQ',
    'nav.solutions.ordersAndSales': 'Pedidos y Ventas',
    'nav.solutions.customerSupport': 'Soporte al Cliente',
    'nav.solutions.ecommerce': 'E-commerce',
    'nav.solutions.realEstate': 'Inmobiliaria',
    'nav.solutions.education': 'Educación',
    'nav.solutions.healthcare': 'Salud',
    'nav.solutions.beautyAesthetics': 'Estética y Belleza',
    'nav.solutions.restaurants': 'Restaurantes',

    // Navbar - Tools dropdown
    'nav.tools.capturePopup': 'Popup de Captura',
    'nav.tools.clickToChatAds': 'Anuncios Click-to-Chat',
    'nav.tools.storyAutomation': 'Automatización de Stories',
    'nav.tools.chatButton': 'Botón de Chat',
    'nav.tools.commentReplies': 'Respuesta a Comentarios',
    'nav.tools.qrCodes': 'Códigos QR',
    'nav.tools.reelsReplies': 'Respuesta a Reels',
    'nav.tools.liveChat': 'Live Chat',
    'nav.tools.broadcasts': 'Broadcasts',

    // Navbar - Resources dropdown
    'nav.resources.blog': 'Blog',
    'nav.resources.docs': 'Documentación',
    'nav.resources.successStories': 'Casos de Éxito',
    'nav.resources.affiliateProgram': 'Programa de Afiliados',

    // Navbar - Mobile
    'nav.mobile.prices': 'Precios',

    // Hero Section
    'hero.title.line1': 'AUMENTE VENTAS',
    'hero.title.line2': 'EN SU',
    'hero.subtitle': 'Únase a',
    'hero.subtitleHighlight': 'más de 18.000 empresas',
    'hero.subtitleEnd': 'usando IA para interactuar con sus clientes.',
    'hero.selectCase': 'O seleccione un caso típico',
    'hero.imageAlt': 'Profesional en clínica',
    'hero.businessTypes.aestheticClinic': 'clínica estética',
    'hero.businessTypes.realEstate': 'inmobiliaria',
    'hero.businessTypes.beautySalon': 'salón de belleza',
    'hero.businessTypes.dentalClinic': 'clínica dental',
    'hero.businessTypes.medicalCenter': 'centro médico',

    // AI Tools Section
    'aiTools.headline': 'Herramientas de IA',

    // Features Section
    'features.headline': 'Funcionalidades',

    // Testimonials Section
    'testimonials.headline': 'Lo que dicen nuestros clientes',

    // CTA Section
    'cta.headline': '¿Listo para automatizar sus ventas?',
    'cta.subtitle': 'Empiece ahora y vea resultados en minutos.',
    'cta.button': 'Empezar gratis',

    // Pricing Section
    'pricing.headline': 'Planes y Precios',
    'pricing.starter': 'Starter',
    'pricing.professional': 'Profesional',
    'pricing.enterprise': 'Enterprise',
    'pricing.startFree': 'Empezar gratis',
    'pricing.talkToSales': 'Hablar con ventas',

    // FAQ Section
    'faq.headline': 'Preguntas Frecuentes',

    // Footer
    'footer.description': 'La plataforma #1 de automatización de WhatsApp e Instagram para empresas.',
    'footer.product': 'Producto',
    'footer.features': 'Funcionalidades',
    'footer.pricing': 'Precios',
    'footer.integrations': 'Integraciones',
    'footer.api': 'API',
    'footer.company': 'Empresa',
    'footer.aboutUs': 'Sobre Nosotros',
    'footer.blog': 'Blog',
    'footer.affiliates': 'Afiliados',
    'footer.contact': 'Contacto',
    'footer.resources': 'Recursos',
    'footer.docs': 'Documentación',
    'footer.templates': 'Plantillas',
    'footer.successStories': 'Casos de Éxito',
    'footer.legal': 'Legal',
    'footer.privacy': 'Privacidad',
    'footer.terms': 'Términos de Uso',
    'footer.copyright': '© 2026 ChatAlfa. Todos los derechos reservados.',
    'footer.officialPartner': 'Socio Oficial',

    // Dashboard - Sidebar
    'sidebar.home': 'Inicio',
    'sidebar.automation': 'Automatización',
    'sidebar.calendar': 'Calendario',
    'sidebar.conversations': 'Conversaciones',
    'sidebar.leads': 'Leads',
    'sidebar.contacts': 'Contactos',
    'sidebar.webWidget': 'Widget Web',
    'sidebar.bookingSite': 'Sitio de Reservas',
    'sidebar.billing': 'Facturación',
    'sidebar.settings': 'Configuraciones',
    'sidebar.upgrade': 'Mejorar Plan',
    'sidebar.logout': 'Salir',

    // Dashboard - Common UI
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Eliminar',
    'common.create': 'Crear',
    'common.edit': 'Editar',
    'common.back': 'Volver',
    'common.continue': 'Continuar',
    'common.loading': 'Cargando...',
    'common.saving': 'Guardando...',
    'common.saveChanges': 'Guardar cambios',
    'common.export': 'Exportar',
    'common.all': 'Todos',
    'common.active': 'Activo',
    'common.link': 'Vincular',
    'common.visit': 'Visitar',
    'common.preview': 'Vista previa',
    'common.publish': 'Publicar',
    'common.copy': 'Copiar',
    'common.copied': '¡Copiado!',
    'common.today': 'Hoy',
    'common.day': 'Día',
    'common.week': 'Semana',
    'common.confirmed': 'confirmado',
    'common.pending': 'pendiente',
    'common.status': 'Estado',
    'common.email': 'Email',
    'common.phone': 'Teléfono',
    'common.tags': 'Etiquetas',
    'common.notes': 'Notas',
    'common.total': 'Total',
    'common.name': 'Nombre',
    'common.contact': 'Contacto',
    'common.channel': 'Canal',
    'common.date': 'Fecha',
    'common.configuration': 'Configuración',

    // Flow Builder
    'flow.saveChanges': 'Guardar Cambios',
    'flow.saving': 'Guardando...',
    'flow.testWithAI': 'Probar con IA',
    'flow.textMessage': 'Mensaje de Texto',
    'flow.choiceButtons': 'Botones de Opción',
    'flow.humanHandoff': 'Transferencia Humana',
    'flow.autosaveActive': 'Guardado automático activo',
    'flow.editorBeta': 'Editor Beta',
    'flow.aiResponse': 'Respuesta de IA',
    'flow.multipleChoice': 'Pregunta Múltiple',
    'flow.specialAction': 'Acción Especial',
    'flow.escalateToHuman': 'Escalar a Humano',
    'flow.escalateDescription': 'La IA se pausará y un agente real recibirá una notificación.',
    'flow.writeBotMessage': 'Escriba el mensaje del bot...',
    'flow.selectOption': 'Seleccione una opción:',
    'flow.option': 'Opción',
    'flow.newMessage': 'Nuevo mensaje',
    'flow.welcomeMessage': '¡Bienvenido! ¿Cómo puedo ayudar?',
    'flow.yesInterested': 'Sí, me interesa',
    'flow.noThanks': 'No, gracias',
    'flow.savedAt': 'Guardado a las',
    'flow.sendMessage': 'Envíe un mensaje para probar su bot',
    'flow.typeMessage': 'Escriba un mensaje...',
    'flow.errorProcessing': 'Error al procesar mensaje.',

    // Dashboard Home
    'dashboard.welcome': '¡Hola! Bienvenido de vuelta',
    'dashboard.summary': 'Aquí hay un resumen de lo que está pasando en ChatAlfa.',
    'dashboard.exploreTemplates': 'Explorar Plantillas',
    'dashboard.createNewBot': 'Crear Nuevo Bot',
    'dashboard.myBots': 'Mis Bots',
    'dashboard.activeConversations': 'Conversaciones Activas',
    'dashboard.totalContacts': 'Total de Contactos',
    'dashboard.messages': 'Mensajes',
    'dashboard.quickSetup': 'Configuración Rápida',
    'dashboard.bookingPage': 'Página de Reservas',
    'dashboard.bookingPageDesc': 'Cree un sitio público para que sus clientes agenden citas directamente.',
    'dashboard.setupSite': 'Configurar sitio',
    'dashboard.aiAutomation': 'Automatización con IA',
    'dashboard.aiAutomationDesc': 'Active respuestas inteligentes basadas en GPT-4 para no perder ningún lead.',
    'dashboard.activateAI': 'Activar IA',
    'dashboard.calendar': 'Calendario',
    'dashboard.calendarDesc': 'Gestione todas sus reservas y horarios en un solo lugar.',
    'dashboard.viewCalendar': 'Ver mi calendario',
    'dashboard.importContacts': 'Importar Contactos',
    'dashboard.importContactsDesc': 'Cargue su base de datos actual para iniciar conversaciones masivas o recordatorios.',
    'dashboard.uploadCSV': 'Enviar CSV/Excel',
    'dashboard.growthTips': 'Consejos para Crecer',
    'dashboard.boostBookings': 'Aumente sus reservas',
    'dashboard.boostBookingsDesc': 'Use el código QR en su establecimiento para que los clientes agenden la próxima cita solos por WhatsApp.',
    'dashboard.getQR': 'Obtener mi QR',
    'dashboard.connectionStatus': 'Estado de Conexión',

    // Leads Page
    'leads.title': 'Leads',
    'leads.subtitle': 'Gestione sus leads y contactos capturados',
    'leads.exportCSV': 'Exportar CSV',
    'leads.searchPlaceholder': 'Buscar por nombre, email o teléfono...',
    'leads.statusNew': 'Nuevo',
    'leads.statusContacted': 'Contactado',
    'leads.statusQualified': 'Calificado',
    'leads.statusConverted': 'Convertido',
    'leads.noLeads': 'Ningún lead encontrado',
    'leads.noLeadsDesc': 'Los leads capturados por sus chatbots aparecerán aquí',
    'leads.viewDetails': 'Ver detalles',
    'leads.markAsContacted': 'Marcar como contactado',
    'leads.showing': 'Mostrando',
    'leads.of': 'de',
    'leads.newTag': 'Nueva etiqueta',
    'leads.addNote': 'Agregar una nota...',
    'leads.noNotes': 'Ninguna nota aún',
    'leads.conversationHistory': 'Historial de Conversaciones',
    'leads.noConversations': 'Ninguna conversación registrada',
    'leads.deleteNote': '¿Eliminar esta nota?',

    // Calendar Page
    'calendar.title': 'Calendario',
    'calendar.allSpecialists': 'Todos los especialistas',
    'calendar.setupComplete': 'Configuración 75% completa',
    'calendar.setupReminder': 'Solo falta activar los recordatorios por WhatsApp para automatizar sus ventas 100%.',
    'calendar.completeSetup': 'Completar configuración',
    'calendar.client': 'Cliente',
    'calendar.service': 'Servicio',
    'calendar.dayNames': ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'],
    'calendar.dayLetters': ['d', 'l', 'm', 'm', 'j', 'v', 's'],
    'calendar.connectCalendar': 'Conectar el calendario',
    'calendar.activateReminders': 'Activar recordatorios',
    'calendar.createFirstBooking': 'Crear su primera reserva',
    'calendar.setupServices': 'Configurar sus servicios',
    'calendar.addSpecialists': 'Agregar especialistas',
    'calendar.createBookingPage': 'Crear página de reservas',
    'calendar.activateMessageAutomation': 'Activar automatización de mensajes',

    // Billing Page
    'billing.title': 'Facturación',
    'billing.subtitle': 'Gestione su plan y uso de conversaciones',
    'billing.loadError': 'Error al cargar información de suscripción',
    'billing.currentPlan': 'Plan Actual',
    'billing.paymentPending': 'Pago pendiente',
    'billing.cancelled': 'Cancelado',
    'billing.perMonth': '/mes',
    'billing.conversationsThisMonth': 'Conversaciones este mes',
    'billing.nearLimit': '¡Está cerca del límite! Considere hacer upgrade.',
    'billing.nextRenewal': 'Próxima renovación',
    'billing.upgrade': 'Hacer Upgrade',
    'billing.recommended': 'Recomendado',
    'billing.conversationsPerMonth': 'conversaciones/mes',
    'billing.upgradeTo': 'Upgrade a',
    'billing.websiteChat': 'Website chat',
    'billing.qrCodes': 'QR Codes',
    'billing.whatsappInstagram': 'WhatsApp + Instagram',
    'billing.chatgptIntegrated': 'ChatGPT integrado',
    'billing.massBroadcasts': 'Broadcasts masivos',
    'billing.everythingInBusiness': 'Todo de Business',
    'billing.support247': 'Soporte 24/7',
    'billing.dedicatedManager': 'Gerente dedicado',
    'billing.manageSubscription': 'Gestionar Suscripción',
    'billing.manageSubDesc': 'Acceda al portal de facturación para actualizar método de pago, ver facturas o cancelar suscripción.',
    'billing.openBillingPortal': 'Abrir Portal de Facturación',
    'billing.usageTip': 'Consejo de uso',
    'billing.usageTipDesc': 'Una conversación se cuenta cuando un usuario inicia una interacción con su bot. Todos los mensajes dentro de una ventana de 24 horas cuentan como una sola conversación.',

    // Booking Page Creator
    'booking.title': 'Sitio de Reservas',
    'booking.subtitle': 'Configure su página pública para que los clientes agenden citas directamente.',
    'booking.savedSuccess': '¡Configuración guardada con éxito!',
    'booking.saveError': 'Error al guardar la configuración',
    'booking.connectionError': 'Error de conexión con el servidor',
    'booking.tabGeneral': 'General',
    'booking.tabServices': 'Servicios',
    'booking.tabAppearance': 'Apariencia',
    'booking.tabBotIntegration': 'Integración Bot',
    'booking.generalInfo': 'Información General',
    'booking.clinicName': 'Nombre de la Clínica / Negocio',
    'booking.clinicNamePlaceholder': 'Ej: Clínica Dental San José',
    'booking.slug': 'URL Amigable (Slug)',
    'booking.shortDescription': 'Descripción Corta',
    'booking.descriptionPlaceholder': 'Describa lo que hace...',
    'booking.contactPhone': 'Teléfono de Contacto',
    'booking.address': 'Dirección',
    'booking.addressPlaceholder': 'Calle Ejemplo, 123, Ciudad',
    'booking.pageUrl': 'URL de su página',
    'booking.yourServices': 'Sus Servicios',
    'booking.addService': 'Agregar Servicio',
    'booking.serviceName': 'Nombre del Servicio',
    'booking.serviceNamePlaceholder': 'Ej: Limpieza facial',
    'booking.price': 'Precio',
    'booking.duration': 'Duración',
    'booking.serviceDescription': 'Descripción del Servicio',
    'booking.serviceDescPlaceholder': 'Breve explicación de lo que incluye el servicio.',
    'booking.botIntegration': 'Integración con el Bot',
    'booking.autoBookingAI': 'Reserva Automática por IA',
    'booking.autoBookingDesc': 'Su bot de IA puede agendar citas usando estos servicios.',
    'booking.bookingFlow': 'Flujo de Reserva',
    'booking.flowStep1': 'Cliente elige el servicio',
    'booking.flowStep2': 'IA verifica disponibilidad en el Calendario',
    'booking.flowStep3': 'Confirmación enviada por WhatsApp',

    // Widget Generator
    'widget.title': 'Widget Web',
    'widget.subtitle': 'Integre su agente de IA en cualquier sitio con solo una línea de código.',
    'widget.view': 'Visualizar',
    'widget.customization': 'Personalización',
    'widget.customizationDesc': 'Configure cómo aparecerá el chat en su sitio.',
    'widget.activeBot': 'Bot Activo',
    'widget.brandColor': 'Color de Marca',
    'widget.chatTitle': 'Título del Chat',
    'widget.chatTitlePlaceholder': 'Ej: Chat con Soporte',
    'widget.welcomeMessage': 'Mensaje de Bienvenida',
    'widget.welcomePlaceholder': 'Ej: ¡Hola! ¿Cómo puedo ayudar?',
    'widget.mobileOptimized': 'Optimizado para móvil',
    'widget.mobileDesc': 'El widget se adapta automáticamente al tamaño de la pantalla, garantizando una experiencia premium en dispositivos móviles.',
    'widget.testMobile': 'Probar en móvil',
    'widget.installCode': 'Código de Instalación',
    'widget.installDesc': 'Copie este código y péguelo antes de la etiqueta </body> en su HTML.',
    'widget.sitePreview': 'Vista previa en su sitio...',
    'widget.online': 'En línea',
    'widget.typePlaceholder': 'Escriba un mensaje...',
    'widget.defaultTitle': 'Chat con IA',
    'widget.defaultWelcome': '¡Hola! ¿Cómo puedo ayudarle hoy?',
    'widget.welcomeMessagePlaceholder': 'Ej: ¡Hola! ¿Cómo puedo ayudar?',
    'widget.mobileOptimizedDesc': 'El widget se adapta automáticamente al tamaño de la pantalla, garantizando una experiencia premium en dispositivos móviles.',
    'widget.testOnMobile': 'Probar en móvil',
    'widget.installCodeDesc': 'Copie este código y péguelo antes de la etiqueta </body> en su HTML.',
    'widget.previewOnSite': 'Vista previa en su sitio...',

    // Booking - missing keys
    'booking.slugPlaceholder': 'ej: clinica-dental-alfa',
    'booking.shortDescriptionPlaceholder': 'Describa lo que hace...',
    'booking.contactPhonePlaceholder': '+34 600 000 000',
    'booking.serviceDescriptionPlaceholder': 'Breve explicación de lo que incluye el servicio.',
    'booking.visit': 'Visitar',

    // Calendar - missing key
    'calendar.configureServices': 'Configurar sus servicios',

    // Onboarding Page
    'onboarding.companyInfo': 'Información de su empresa',
    'onboarding.step1Title': 'Elija la industria',
    'onboarding.step2Title': 'Configure los servicios',
    'onboarding.step3Title': 'Presencia online',
    'onboarding.step4Title': 'Primera reserva',
    'onboarding.copyright': '© 2026 ChatAlfa - Impulsado por IA',
    'onboarding.chooseIndustry': 'Elija su industria',
    'onboarding.chooseIndustryDesc': 'Cargaremos textos, intenciones y tono optimizados para su tipo de negocio.',
    'onboarding.industryLabel': 'Industria',
    'onboarding.specialtyLabel': 'Especialidad',
    'onboarding.chooseSpecialty': 'Elija la especialidad',
    'onboarding.teamSizeLabel': '¿Cuántas personas trabajan en su negocio?',
    'onboarding.digitalReceptionist': 'Recepcionista digital 24/7',
    'onboarding.setupCalendar': 'Configure su calendario',
    'onboarding.setupCalendarDesc': 'Sus pacientes pueden agendar citas 24/7 — incluso mientras usted descansa.',
    'onboarding.companyNameLabel': 'Nombre de la empresa',
    'onboarding.companyNamePlaceholder': 'Ej. Clínica Dental Alfa',
    'onboarding.phoneLabel': 'Número de teléfono de la empresa',
    'onboarding.phonePlaceholder': '+34 600 000 000',
    'onboarding.saveTime': 'Ahorre tiempo valioso',
    'onboarding.saveTimeDesc': 'Recupere hasta 3 horas por semana para el cuidado de sus pacientes o su familia.',
    'onboarding.autoReminders': 'Recordatorios automáticos',
    'onboarding.reduceNoShows': 'Reduzca las ausencias',
    'onboarding.reminderConfirmation': 'Confirmación de reserva',
    'onboarding.reminderConfirmationDesc': 'El paciente recibe confirmación instantánea después de agendar',
    'onboarding.reminder24h': 'Recordatorio en 24h',
    'onboarding.reminder24hDesc': 'Un mensaje que recuerda la cita con 3 botones para confirmar, reagendar o cancelar',
    'onboarding.reminder2h': 'Recordatorio en 2h',
    'onboarding.reminder2hDesc': 'Recordatorio el mismo día para que los pacientes no olviden la cita',
    'onboarding.provenEfficiency': 'Eficacia comprobada',
    'onboarding.provenEfficiencyDesc': 'Esto reduce las ausencias hasta un 38% — menos horarios vacíos en su agenda.',
    'onboarding.automateMessages': 'Automatice los mensajes',
    'onboarding.automateMessagesIntro': 'Automatice mensajes recibidos',
    'onboarding.automateMessagesDesc': '¿Le gustaría un recepcionista digital para responder mensajes y agendar citas automáticamente?',
    'onboarding.yesAutomate': 'Me gustaría automatizar los mensajes',
    'onboarding.yesAutomateDesc': '¡Excelente! Su recepcionista digital estará listo.',
    'onboarding.notNow': 'Ahora no',
    'onboarding.firstBooking': 'Primera reserva',
    'onboarding.firstBookingDesc': 'Haga clic en el botón de abajo para crear una reserva de prueba. Enviaremos la confirmación a',
    'onboarding.notConfirmed': 'No confirmada',
    'onboarding.initialConsultation': 'Consulta inicial',
    'onboarding.by': 'por',
    'onboarding.markConfirmed': 'Marcar como confirmada',
    'onboarding.createFirstBooking': 'Crear mi primera reserva',
    'onboarding.done': '¡Listo! Notificación enviada',
    'onboarding.doneDesc': 'No necesita perseguir a los pacientes — enviaremos los recordatorios y actualizaremos el estado automáticamente cuando respondan.',
    'onboarding.confirmed': 'Confirmada',
    'onboarding.finish': 'Finalizar',

    // Onboarding industries
    'onboarding.ind.salud': 'Salud',
    'onboarding.ind.saludDesc': 'Clínicas, médicos, dentistas y profesionales médicos licenciados',
    'onboarding.ind.bienestar': 'Bienestar y salud integrativa',
    'onboarding.ind.bienestarDesc': 'Nutricionistas, osteópatas, quiroprácticos y profesionales de salud holística',
    'onboarding.ind.belleza': 'Belleza y cuidado personal',
    'onboarding.ind.bellezaDesc': 'Salones, spas, barberías, cuidado de la piel y profesionales cosméticos',
    'onboarding.ind.fitness': 'Fitness y bienestar',
    'onboarding.ind.fitnessDesc': 'Gimnasios, entrenadores personales, instructores de yoga o pilates',
    'onboarding.ind.auto': 'Servicios automotrices y de transporte',
    'onboarding.ind.autoDesc': 'Negocios que ofrecen reparación de vehículos, transporte o servicios de entrega',
    'onboarding.ind.educacion': 'Educación y coaching',
    'onboarding.ind.educacionDesc': 'Tutores, formadores o coaches personales y de negocios',
    'onboarding.ind.creativos': 'Eventos y creativos',
    'onboarding.ind.creativosDesc': 'Organizadores de eventos, fotógrafos, diseñadores y freelancers creativos',
    'onboarding.ind.alimentos': 'Alimentación y entregas',
    'onboarding.ind.alimentosDesc': 'Restaurantes, catering o servicios de entrega de comida',
    'onboarding.ind.hogar': 'Servicios para el hogar y locales',
    'onboarding.ind.hogarDesc': 'Limpieza, reparaciones y otros servicios domésticos locales',
    'onboarding.ind.mascotas': 'Servicios para mascotas',
    'onboarding.ind.mascotasDesc': 'Grooming, adiestramiento, hospedaje o servicios veterinarios',
    'onboarding.ind.inmobiliaria': 'Inmobiliaria',
    'onboarding.ind.inmobiliariaDesc': 'Agentes, corredores o servicios de administración de propiedades',
    'onboarding.ind.viajes': 'Viajes',
    'onboarding.ind.viajesDesc': 'Agencias de viaje, guías o servicios relacionados con la hospitalidad',
    'onboarding.ind.retail': 'Retail y e-commerce',
    'onboarding.ind.retailDesc': 'Tiendas online o físicas que venden productos',
    'onboarding.ind.pro': 'Servicios profesionales',
    'onboarding.ind.proDesc': 'Finanzas, legal, agencias y profesionales independientes',

    // Onboarding specialties
    'onboarding.spec.aestheticMedicine': 'Medicina estética',
    'onboarding.spec.cardiology': 'Cardiología',
    'onboarding.spec.dentistry': 'Odontología',
    'onboarding.spec.dermatology': 'Dermatología',
    'onboarding.spec.endocrinology': 'Endocrinología',
    'onboarding.spec.ent': 'Otorrinolaringología (ORL)',
    'onboarding.spec.multiClinic': 'Clínica multidisciplinar',
    'onboarding.spec.gynecology': 'Ginecología',
    'onboarding.spec.neurology': 'Neurología',
    'onboarding.spec.oncology': 'Oncología',
    'onboarding.spec.ophthalmology': 'Oftalmología',
    'onboarding.spec.orthopedics': 'Ortopedia',
    'onboarding.spec.pediatrics': 'Pediatría',
    'onboarding.spec.mentalHealth': 'Salud mental',
    'onboarding.spec.surgery': 'Cirugía',
    'onboarding.spec.other': 'Otra',
  },

  en: {
    // Navbar
    'nav.channels': 'Channels',
    'nav.solutions': 'Solutions',
    'nav.tools': 'Tools',
    'nav.templates': 'Templates',
    'nav.resources': 'Resources',
    'nav.integrations': 'Integrations',
    'nav.login': 'Log in',
    'nav.startFree': 'Start free',
    'nav.dashboard': 'Dashboard',
    'nav.logout': 'Log out',

    // Navbar - Channels dropdown
    'nav.channels.whatsapp.desc': 'Business API Automation',
    'nav.channels.instagram.desc': 'DMs, Stories & Reels',
    'nav.channels.facebook.desc': 'Messenger & Comments',
    'nav.channels.tiktok.desc': 'Automatic engagement',
    'nav.channels.website.desc': 'Floating chat & Popups',

    // Navbar - Solutions dropdown
    'nav.solutions.useCases': 'Use Cases',
    'nav.solutions.industries': 'Industries',
    'nav.solutions.leadQualification': 'Lead Qualification',
    'nav.solutions.appointments': 'Appointments',
    'nav.solutions.faqAnswers': 'FAQ Answers',
    'nav.solutions.ordersAndSales': 'Orders & Sales',
    'nav.solutions.customerSupport': 'Customer Support',
    'nav.solutions.ecommerce': 'E-commerce',
    'nav.solutions.realEstate': 'Real Estate',
    'nav.solutions.education': 'Education',
    'nav.solutions.healthcare': 'Healthcare',
    'nav.solutions.beautyAesthetics': 'Beauty & Aesthetics',
    'nav.solutions.restaurants': 'Restaurants',

    // Navbar - Tools dropdown
    'nav.tools.capturePopup': 'Capture Popup',
    'nav.tools.clickToChatAds': 'Click-to-Chat Ads',
    'nav.tools.storyAutomation': 'Story Automation',
    'nav.tools.chatButton': 'Chat Button',
    'nav.tools.commentReplies': 'Comment Replies',
    'nav.tools.qrCodes': 'QR Codes',
    'nav.tools.reelsReplies': 'Reels Replies',
    'nav.tools.liveChat': 'Live Chat',
    'nav.tools.broadcasts': 'Broadcasts',

    // Navbar - Resources dropdown
    'nav.resources.blog': 'Blog',
    'nav.resources.docs': 'Documentation',
    'nav.resources.successStories': 'Success Stories',
    'nav.resources.affiliateProgram': 'Affiliate Program',

    // Navbar - Mobile
    'nav.mobile.prices': 'Pricing',

    // Hero Section
    'hero.title.line1': 'BOOST SALES',
    'hero.title.line2': 'FOR YOUR',
    'hero.subtitle': 'Join',
    'hero.subtitleHighlight': 'over 18,000 businesses',
    'hero.subtitleEnd': 'using AI to engage with their customers.',
    'hero.selectCase': 'Or select a typical use case',
    'hero.imageAlt': 'Clinic professional',
    'hero.businessTypes.aestheticClinic': 'aesthetic clinic',
    'hero.businessTypes.realEstate': 'real estate',
    'hero.businessTypes.beautySalon': 'beauty salon',
    'hero.businessTypes.dentalClinic': 'dental clinic',
    'hero.businessTypes.medicalCenter': 'medical center',

    // AI Tools Section
    'aiTools.headline': 'AI Tools',

    // Features Section
    'features.headline': 'Features',

    // Testimonials Section
    'testimonials.headline': 'What our customers say',

    // CTA Section
    'cta.headline': 'Ready to automate your sales?',
    'cta.subtitle': 'Start now and see results in minutes.',
    'cta.button': 'Start free',

    // Pricing Section
    'pricing.headline': 'Plans & Pricing',
    'pricing.starter': 'Starter',
    'pricing.professional': 'Professional',
    'pricing.enterprise': 'Enterprise',
    'pricing.startFree': 'Start free',
    'pricing.talkToSales': 'Talk to sales',

    // FAQ Section
    'faq.headline': 'Frequently Asked Questions',

    // Footer
    'footer.description': 'The #1 WhatsApp and Instagram automation platform for businesses.',
    'footer.product': 'Product',
    'footer.features': 'Features',
    'footer.pricing': 'Pricing',
    'footer.integrations': 'Integrations',
    'footer.api': 'API',
    'footer.company': 'Company',
    'footer.aboutUs': 'About Us',
    'footer.blog': 'Blog',
    'footer.affiliates': 'Affiliates',
    'footer.contact': 'Contact',
    'footer.resources': 'Resources',
    'footer.docs': 'Documentation',
    'footer.templates': 'Templates',
    'footer.successStories': 'Success Stories',
    'footer.legal': 'Legal',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms of Service',
    'footer.copyright': '© 2026 ChatAlfa. All rights reserved.',
    'footer.officialPartner': 'Official Partner',

    // Dashboard - Sidebar
    'sidebar.home': 'Home',
    'sidebar.automation': 'Automation',
    'sidebar.calendar': 'Calendar',
    'sidebar.conversations': 'Conversations',
    'sidebar.leads': 'Leads',
    'sidebar.contacts': 'Contacts',
    'sidebar.webWidget': 'Web Widget',
    'sidebar.bookingSite': 'Booking Site',
    'sidebar.billing': 'Billing',
    'sidebar.settings': 'Settings',
    'sidebar.upgrade': 'Upgrade Plan',
    'sidebar.logout': 'Log out',

    // Dashboard - Common UI
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.create': 'Create',
    'common.edit': 'Edit',
    'common.back': 'Back',
    'common.continue': 'Continue',
    'common.loading': 'Loading...',
    'common.saving': 'Saving...',
    'common.saveChanges': 'Save changes',
    'common.export': 'Export',
    'common.all': 'All',
    'common.active': 'Active',
    'common.link': 'Link',
    'common.visit': 'Visit',
    'common.preview': 'Preview',
    'common.publish': 'Publish',
    'common.copy': 'Copy',
    'common.copied': 'Copied!',
    'common.today': 'Today',
    'common.day': 'Day',
    'common.week': 'Week',
    'common.confirmed': 'confirmed',
    'common.pending': 'pending',
    'common.status': 'Status',
    'common.email': 'Email',
    'common.phone': 'Phone',
    'common.tags': 'Tags',
    'common.notes': 'Notes',
    'common.total': 'Total',
    'common.name': 'Name',
    'common.contact': 'Contact',
    'common.channel': 'Channel',
    'common.date': 'Date',
    'common.configuration': 'Configuration',

    // Flow Builder
    'flow.saveChanges': 'Save Changes',
    'flow.saving': 'Saving...',
    'flow.testWithAI': 'Test with AI',
    'flow.textMessage': 'Text Message',
    'flow.choiceButtons': 'Choice Buttons',
    'flow.humanHandoff': 'Human Handoff',
    'flow.autosaveActive': 'Autosave active',
    'flow.editorBeta': 'Editor Beta',
    'flow.aiResponse': 'AI Response',
    'flow.multipleChoice': 'Multiple Choice',
    'flow.specialAction': 'Special Action',
    'flow.escalateToHuman': 'Escalate to Human',
    'flow.escalateDescription': 'AI will be paused and a real agent will be notified.',
    'flow.writeBotMessage': 'Write the bot message...',
    'flow.selectOption': 'Select an option:',
    'flow.option': 'Option',
    'flow.newMessage': 'New message',
    'flow.welcomeMessage': 'Welcome! How can I help?',
    'flow.yesInterested': 'Yes, I\'m interested',
    'flow.noThanks': 'No, thanks',
    'flow.savedAt': 'Saved at',
    'flow.sendMessage': 'Send a message to test your bot',
    'flow.typeMessage': 'Type a message...',
    'flow.errorProcessing': 'Error processing message.',

    // Dashboard Home
    'dashboard.welcome': 'Hello! Welcome back',
    'dashboard.summary': 'Here\'s a summary of what\'s happening on ChatAlfa.',
    'dashboard.exploreTemplates': 'Explore Templates',
    'dashboard.createNewBot': 'Create New Bot',
    'dashboard.myBots': 'My Bots',
    'dashboard.activeConversations': 'Active Conversations',
    'dashboard.totalContacts': 'Total Contacts',
    'dashboard.messages': 'Messages',
    'dashboard.quickSetup': 'Quick Setup',
    'dashboard.bookingPage': 'Booking Page',
    'dashboard.bookingPageDesc': 'Create a public site so your clients can book appointments directly.',
    'dashboard.setupSite': 'Setup site',
    'dashboard.aiAutomation': 'AI Automation',
    'dashboard.aiAutomationDesc': 'Activate smart responses powered by GPT-4 to never miss a lead.',
    'dashboard.activateAI': 'Activate AI',
    'dashboard.calendar': 'Calendar',
    'dashboard.calendarDesc': 'Manage all your bookings and schedules in one place.',
    'dashboard.viewCalendar': 'View my calendar',
    'dashboard.importContacts': 'Import Contacts',
    'dashboard.importContactsDesc': 'Upload your current database to start mass conversations or reminders.',
    'dashboard.uploadCSV': 'Upload CSV/Excel',
    'dashboard.growthTips': 'Growth Tips',
    'dashboard.boostBookings': 'Boost your bookings',
    'dashboard.boostBookingsDesc': 'Use the QR code at your location so clients can book their next appointment via WhatsApp.',
    'dashboard.getQR': 'Get my QR',
    'dashboard.connectionStatus': 'Connection Status',

    // Leads Page
    'leads.title': 'Leads',
    'leads.subtitle': 'Manage your leads and captured contacts',
    'leads.exportCSV': 'Export CSV',
    'leads.searchPlaceholder': 'Search by name, email or phone...',
    'leads.statusNew': 'New',
    'leads.statusContacted': 'Contacted',
    'leads.statusQualified': 'Qualified',
    'leads.statusConverted': 'Converted',
    'leads.noLeads': 'No leads found',
    'leads.noLeadsDesc': 'Leads captured by your chatbots will appear here',
    'leads.viewDetails': 'View details',
    'leads.markAsContacted': 'Mark as contacted',
    'leads.showing': 'Showing',
    'leads.of': 'of',
    'leads.newTag': 'New tag',
    'leads.addNote': 'Add a note...',
    'leads.noNotes': 'No notes yet',
    'leads.conversationHistory': 'Conversation History',
    'leads.noConversations': 'No conversations recorded',
    'leads.deleteNote': 'Delete this note?',

    // Calendar Page
    'calendar.title': 'Calendar',
    'calendar.allSpecialists': 'All specialists',
    'calendar.setupComplete': 'Setup 75% complete',
    'calendar.setupReminder': 'Just activate WhatsApp reminders to automate your sales 100%.',
    'calendar.completeSetup': 'Complete setup',
    'calendar.client': 'Client',
    'calendar.service': 'Service',
    'calendar.dayNames': ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
    'calendar.dayLetters': ['s', 'm', 't', 'w', 't', 'f', 's'],
    'calendar.connectCalendar': 'Connect calendar',
    'calendar.activateReminders': 'Activate reminders',
    'calendar.createFirstBooking': 'Create your first booking',
    'calendar.setupServices': 'Setup your services',
    'calendar.addSpecialists': 'Add specialists',
    'calendar.createBookingPage': 'Create booking page',
    'calendar.activateMessageAutomation': 'Activate message automation',

    // Billing Page
    'billing.title': 'Billing',
    'billing.subtitle': 'Manage your plan and conversation usage',
    'billing.loadError': 'Error loading subscription information',
    'billing.currentPlan': 'Current Plan',
    'billing.paymentPending': 'Payment pending',
    'billing.cancelled': 'Cancelled',
    'billing.perMonth': '/month',
    'billing.conversationsThisMonth': 'Conversations this month',
    'billing.nearLimit': 'You\'re close to the limit! Consider upgrading.',
    'billing.nextRenewal': 'Next renewal',
    'billing.upgrade': 'Upgrade',
    'billing.recommended': 'Recommended',
    'billing.conversationsPerMonth': 'conversations/month',
    'billing.upgradeTo': 'Upgrade to',
    'billing.websiteChat': 'Website chat',
    'billing.qrCodes': 'QR Codes',
    'billing.whatsappInstagram': 'WhatsApp + Instagram',
    'billing.chatgptIntegrated': 'ChatGPT integrated',
    'billing.massBroadcasts': 'Mass broadcasts',
    'billing.everythingInBusiness': 'Everything in Business',
    'billing.support247': '24/7 Support',
    'billing.dedicatedManager': 'Dedicated manager',
    'billing.manageSubscription': 'Manage Subscription',
    'billing.manageSubDesc': 'Access the billing portal to update payment method, view invoices or cancel subscription.',
    'billing.openBillingPortal': 'Open Billing Portal',
    'billing.usageTip': 'Usage tip',
    'billing.usageTipDesc': 'A conversation is counted when a user starts an interaction with your bot. All messages within a 24-hour window count as a single conversation.',

    // Booking Page Creator
    'booking.title': 'Booking Site',
    'booking.subtitle': 'Configure your public page so clients can book appointments directly.',
    'booking.savedSuccess': 'Configuration saved successfully!',
    'booking.saveError': 'Error saving configuration',
    'booking.connectionError': 'Server connection error',
    'booking.tabGeneral': 'General',
    'booking.tabServices': 'Services',
    'booking.tabAppearance': 'Appearance',
    'booking.tabBotIntegration': 'Bot Integration',
    'booking.generalInfo': 'General Information',
    'booking.clinicName': 'Clinic / Business Name',
    'booking.clinicNamePlaceholder': 'E.g.: St. Joseph Dental Clinic',
    'booking.slug': 'Friendly URL (Slug)',
    'booking.shortDescription': 'Short Description',
    'booking.descriptionPlaceholder': 'Describe what you do...',
    'booking.contactPhone': 'Contact Phone',
    'booking.address': 'Address',
    'booking.addressPlaceholder': '123 Example St, City',
    'booking.pageUrl': 'Your page URL',
    'booking.yourServices': 'Your Services',
    'booking.addService': 'Add Service',
    'booking.serviceName': 'Service Name',
    'booking.serviceNamePlaceholder': 'E.g.: Facial cleansing',
    'booking.price': 'Price',
    'booking.duration': 'Duration',
    'booking.serviceDescription': 'Service Description',
    'booking.serviceDescPlaceholder': 'Brief explanation of what the service includes.',
    'booking.botIntegration': 'Bot Integration',
    'booking.autoBookingAI': 'AI Automatic Booking',
    'booking.autoBookingDesc': 'Your AI bot can schedule appointments using these services.',
    'booking.bookingFlow': 'Booking Flow',
    'booking.flowStep1': 'Client chooses the service',
    'booking.flowStep2': 'AI checks availability in Calendar',
    'booking.flowStep3': 'Confirmation sent via WhatsApp',

    // Widget Generator
    'widget.title': 'Web Widget',
    'widget.subtitle': 'Integrate your AI agent on any website with just one line of code.',
    'widget.view': 'Preview',
    'widget.customization': 'Customization',
    'widget.customizationDesc': 'Configure how the chat will appear on your site.',
    'widget.activeBot': 'Active Bot',
    'widget.brandColor': 'Brand Color',
    'widget.chatTitle': 'Chat Title',
    'widget.chatTitlePlaceholder': 'E.g.: Chat with Support',
    'widget.welcomeMessage': 'Welcome Message',
    'widget.welcomePlaceholder': 'E.g.: Hello! How can I help?',
    'widget.mobileOptimized': 'Mobile optimized',
    'widget.mobileDesc': 'The widget automatically adapts to screen size, ensuring a premium experience on mobile devices.',
    'widget.testMobile': 'Test on mobile',
    'widget.installCode': 'Installation Code',
    'widget.installDesc': 'Copy this code and paste it before the </body> tag in your HTML.',
    'widget.sitePreview': 'Preview on your site...',
    'widget.online': 'Online',
    'widget.typePlaceholder': 'Type a message...',
    'widget.defaultTitle': 'AI Chat',
    'widget.defaultWelcome': 'Hello! How can I help you today?',
    'widget.welcomeMessagePlaceholder': 'E.g.: Hello! How can I help?',
    'widget.mobileOptimizedDesc': 'The widget automatically adapts to screen size, ensuring a premium experience on mobile devices.',
    'widget.testOnMobile': 'Test on mobile',
    'widget.installCodeDesc': 'Copy this code and paste it before the </body> tag in your HTML.',
    'widget.previewOnSite': 'Preview on your site...',

    // Booking - missing keys
    'booking.slugPlaceholder': 'e.g.: dental-clinic-alfa',
    'booking.shortDescriptionPlaceholder': 'Describe what you do...',
    'booking.contactPhonePlaceholder': '+1 555 000 0000',
    'booking.serviceDescriptionPlaceholder': 'Brief explanation of what the service includes.',
    'booking.visit': 'Visit',

    // Calendar - missing key
    'calendar.configureServices': 'Configure your services',

    // Onboarding Page
    'onboarding.companyInfo': 'Your company information',
    'onboarding.step1Title': 'Choose industry',
    'onboarding.step2Title': 'Configure services',
    'onboarding.step3Title': 'Online presence',
    'onboarding.step4Title': 'First booking',
    'onboarding.copyright': '© 2026 ChatAlfa - Powered by AI',
    'onboarding.chooseIndustry': 'Choose your industry',
    'onboarding.chooseIndustryDesc': 'We\'ll load optimized text, intents, and tone for your business type.',
    'onboarding.industryLabel': 'Industry',
    'onboarding.specialtyLabel': 'Specialty',
    'onboarding.chooseSpecialty': 'Choose specialty',
    'onboarding.teamSizeLabel': 'How many people work in your business?',
    'onboarding.digitalReceptionist': 'Digital receptionist 24/7',
    'onboarding.setupCalendar': 'Set up your calendar',
    'onboarding.setupCalendarDesc': 'Your patients can book appointments 24/7 — even while you rest.',
    'onboarding.companyNameLabel': 'Company name',
    'onboarding.companyNamePlaceholder': 'E.g. Alfa Dental Clinic',
    'onboarding.phoneLabel': 'Business phone number',
    'onboarding.phonePlaceholder': '+1 555 000 0000',
    'onboarding.saveTime': 'Save valuable time',
    'onboarding.saveTimeDesc': 'Recover up to 3 hours per week for patient care or your family.',
    'onboarding.autoReminders': 'Automatic reminders',
    'onboarding.reduceNoShows': 'Reduce no-shows',
    'onboarding.reminderConfirmation': 'Booking confirmation',
    'onboarding.reminderConfirmationDesc': 'Patient receives instant confirmation after booking',
    'onboarding.reminder24h': '24h reminder',
    'onboarding.reminder24hDesc': 'A message reminding about the appointment with 3 buttons to confirm, reschedule or cancel',
    'onboarding.reminder2h': '2h reminder',
    'onboarding.reminder2hDesc': 'Same-day reminder so patients don\'t forget their appointment',
    'onboarding.provenEfficiency': 'Proven effectiveness',
    'onboarding.provenEfficiencyDesc': 'This reduces no-shows by up to 38% — fewer empty slots in your schedule.',
    'onboarding.automateMessages': 'Automate messages',
    'onboarding.automateMessagesIntro': 'Automate incoming messages',
    'onboarding.automateMessagesDesc': 'Would you like a digital receptionist to answer messages and book appointments automatically?',
    'onboarding.yesAutomate': 'I\'d like to automate messages',
    'onboarding.yesAutomateDesc': 'Excellent! Your digital receptionist will be ready.',
    'onboarding.notNow': 'Not now',
    'onboarding.firstBooking': 'First booking',
    'onboarding.firstBookingDesc': 'Click the button below to create a test booking. We\'ll send the confirmation to',
    'onboarding.notConfirmed': 'Not confirmed',
    'onboarding.initialConsultation': 'Initial consultation',
    'onboarding.by': 'by',
    'onboarding.markConfirmed': 'Mark as confirmed',
    'onboarding.createFirstBooking': 'Create my first booking',
    'onboarding.done': 'Done! Notification sent',
    'onboarding.doneDesc': 'You don\'t need to chase patients — we\'ll send reminders and update the status automatically when they respond.',
    'onboarding.confirmed': 'Confirmed',
    'onboarding.finish': 'Finish',

    // Onboarding industries
    'onboarding.ind.salud': 'Healthcare',
    'onboarding.ind.saludDesc': 'Clinics, doctors, dentists and licensed medical professionals',
    'onboarding.ind.bienestar': 'Wellness & integrative health',
    'onboarding.ind.bienestarDesc': 'Nutritionists, osteopaths, chiropractors and holistic health professionals',
    'onboarding.ind.belleza': 'Beauty & personal care',
    'onboarding.ind.bellezaDesc': 'Salons, spas, barbershops, skincare and cosmetic professionals',
    'onboarding.ind.fitness': 'Fitness & wellness',
    'onboarding.ind.fitnessDesc': 'Gyms, personal trainers, yoga or pilates instructors',
    'onboarding.ind.auto': 'Automotive & transport services',
    'onboarding.ind.autoDesc': 'Businesses offering vehicle repair, transportation or delivery services',
    'onboarding.ind.educacion': 'Education & coaching',
    'onboarding.ind.educacionDesc': 'Tutors, trainers or personal and business coaches',
    'onboarding.ind.creativos': 'Events & creatives',
    'onboarding.ind.creativosDesc': 'Event organizers, photographers, designers and creative freelancers',
    'onboarding.ind.alimentos': 'Food & delivery',
    'onboarding.ind.alimentosDesc': 'Restaurants, catering or meal delivery services',
    'onboarding.ind.hogar': 'Home & local services',
    'onboarding.ind.hogarDesc': 'Cleaning, repairs and other local domestic services',
    'onboarding.ind.mascotas': 'Pet services',
    'onboarding.ind.mascotasDesc': 'Grooming, training, boarding or veterinary services',
    'onboarding.ind.inmobiliaria': 'Real estate',
    'onboarding.ind.inmobiliariaDesc': 'Agents, brokers or property management services',
    'onboarding.ind.viajes': 'Travel',
    'onboarding.ind.viajesDesc': 'Travel agencies, guides or hospitality-related services',
    'onboarding.ind.retail': 'Retail & e-commerce',
    'onboarding.ind.retailDesc': 'Online or physical stores selling products',
    'onboarding.ind.pro': 'Professional services',
    'onboarding.ind.proDesc': 'Finance, legal, agencies and independent professionals',

    // Onboarding specialties
    'onboarding.spec.aestheticMedicine': 'Aesthetic medicine',
    'onboarding.spec.cardiology': 'Cardiology',
    'onboarding.spec.dentistry': 'Dentistry',
    'onboarding.spec.dermatology': 'Dermatology',
    'onboarding.spec.endocrinology': 'Endocrinology',
    'onboarding.spec.ent': 'Otorhinolaryngology (ENT)',
    'onboarding.spec.multiClinic': 'Multidisciplinary clinic',
    'onboarding.spec.gynecology': 'Gynecology',
    'onboarding.spec.neurology': 'Neurology',
    'onboarding.spec.oncology': 'Oncology',
    'onboarding.spec.ophthalmology': 'Ophthalmology',
    'onboarding.spec.orthopedics': 'Orthopedics',
    'onboarding.spec.pediatrics': 'Pediatrics',
    'onboarding.spec.mentalHealth': 'Mental health',
    'onboarding.spec.surgery': 'Surgery',
    'onboarding.spec.other': 'Other',
  },
};

export default translations;
